import React, { useState } from 'react';
import "../../styles/convocation/main.css";
import { Container, Button, Modal, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Main = () => {
    const [showEvent1, setShowEvent1] = useState(false);
    const [showEvent2, setShowEvent2] = useState(false);
    const [showEvent3, setShowEvent3] = useState(false);
    const [showEvent4, setShowEvent4] = useState(false);

    return (
        <Container className="mt-5 mb-5">
            <h1 className="text-center mb-4 my-heading">
                CCSU Meerut University 36th Convocation
            </h1>

            {/* Cards */}
            <div className="convocation-main">
                <div className="row">
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">Medal & Certificate List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent1(true)}>
                                    <span className="sr-only">Open Medal & Certificate List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">University Campus Courses Merit List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent2(true)}>
                                    <span className="sr-only">Open University Campus Courses Merit List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">Professional Courses Merit List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent3(true)}>
                                    <span className="sr-only">Open Professional Courses Merit List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">Confidential Merit List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent4(true)}>
                                    <span className="sr-only">Open Confidential Merit List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modals */}
            {/* Event 1 Modal */}
            <Modal show={showEvent1} onHide={() => setShowEvent1(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>Medal &amp; Certificate List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered className='table'>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Convocation 2024 Press Release</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/Convocation%202024%20Press%20Release%20.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Convocation Press Release </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/press%20release%20(5).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Convocation Notification</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/Convocation%202024%20Notification.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Convocation Parforma 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/Convocation%20Parforma%202024.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>
                                    Letter
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/01.%20Letter%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Chancellor's Gold Medal List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/02.%20Chancellor's%20Gold%20Medal_List_2024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>DSDS Gold Medal List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/03.%20DSDS%20Gold%20Medal_List_2024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Kisan Trust Award List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/04.%20Kisan%20Trust%20Award_List_2024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>

                            <tr>
                                <td>9</td>
                                <td>Sponcored Gold Medal List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/05.%20Sponcored%20Gold_Medal_List_2024.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>
                                    Vice Chancellor Medal 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/06.%20Vice%20Chancellor%20Medal%202024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>
                                    Merit List 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/07.%20Merit%20List%202024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Vice Chancellor Medal 2023</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/08.%20Vice%20Chancellor%20Medal%202023%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Vice Chancellor Medal 2022</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/09.%20Vice%20Chancellor%20Medal%202022.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>

                            <tr>
                                <td>&nbsp;</td>
                                <td data-value="">&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent1(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Event 2 Modal */}
            <Modal show={showEvent2} onHide={() => setShowEvent2(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>University Campus Courses Merit List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered className='table'>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Updated Date</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td>30-07-2024</td>
                                <td>
                                    Toppers list of campus regular course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/campus_cell.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>31-07-2024</td>
                                <td>
                                    Toppers list of campus regular course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/convocation-01.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>08-08-2024</td>
                                <td>
                                    B.B.A. Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bba_campus.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>08-08-2024</td>
                                <td>
                                    B.P.Ed Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bped_campus.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>08-08-2024</td>
                                <td>
                                    B.Sc. Micro Food Safety & Quality Control
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc_food_safty.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Geography Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_geo%20(2).pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. History Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_his.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Psychology Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_psychology.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Social Work Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_social_work.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Sociology Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_sociology%20(1).pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Economics Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-eco.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Hindi Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-hin.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Sanskrit Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-sanskrit.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.A. Urdu Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-urdu.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.F.A. (Applied Arts) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mfa_app_arts.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.F.A. (Drawing & Painting) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mfa_drawing_paint.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Horticulture Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc_horti.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Botany Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-botany.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Chemistry Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-chem.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Geography Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-geo.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Mathematics Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-maths.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Microbiology Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-microbiology.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Physics Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-phy.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Statistics Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-statistics.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Toxiology Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-toxi.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>08-08-2024</td>
                                <td>
                                    M.Sc. Zoology Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-zoology.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>08-08-2024</td>
                                <td>
                                    P.G. Diploma in Guidance & Councelling (Campus) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/pg_dipl_guide_councel.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>09-08-2024</td>
                                <td>
                                    B.Lib. Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/b.lib_campus.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>09-08-2024</td>
                                <td>
                                    P.G. Diploma in Karmkand Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/pg_diplo_karmkand.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>12-08-2024</td>
                                <td>
                                    M.Ed Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/med-campus.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>12-08-2024</td>
                                <td>
                                    M.Sc. Home Science (Food & Nutrition) Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-home-sc-food-nutrition.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>12-08-2024</td>
                                <td>
                                    LL.M Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/llm-campus.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>12-08-2024</td>
                                <td>
                                    M.A. Political Science (Campus) NEP Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-pol-sc-nep.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>12-08-2024</td>
                                <td>
                                    B.B.A. (Hospital Administration) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bba-ha.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>12-08-2024</td>
                                <td>
                                    Integrated M.B.A. (Hospital Administrative) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/integrated-mba-ha.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>

                            <tr>
                                <td>36</td>
                                <td>13-08-2024</td>
                                <td>
                                    Integrated M.B.A. Hospital Administration Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/integrated-mba-ha-02.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>13-08-2024</td>
                                <td>
                                    Diploma in French Campus 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/diploma-french.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>13-08-2024</td>
                                <td>
                                    C.O.P. in French Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/cop-french.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>13-08-2024</td>
                                <td>
                                    C.O.P. in Russian Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/cop-russian.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>13-08-2024</td>
                                <td>
                                    B.B.A. Hospital Administration Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bba-hosp-admin.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>13-08-2024</td>
                                <td>
                                    Advance Diploma in French Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/adv-french.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>16-08-2024</td>
                                <td>
                                    M.A. Sanskrit Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-sanskrit-campus.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>16-08-2024</td>
                                <td>
                                    M.Ed. (Campus) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/med-campus%20(2).pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>16-08-2024</td>
                                <td>
                                    M.Sc. Bio Chemistry Campus Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-biochem.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>17-08-2024</td>
                                <td>
                                    Revised B.B.A. (Hospital Administration) Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bba-hospital-admin.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>22-08-2024</td>
                                <td>
                                    B.B.A. (Hospital Administration) Campus Year 2023
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bba-ha-03.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>28-08-2024</td>
                                <td>
                                    Revised M.A. English Regular Course Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-eng-rev.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>29-08-2024</td>
                                <td>
                                    Revised M.A. Hindi N.E.P Regular Course Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-hindi-nep-rev.pdf"
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>

                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent2(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Event 3 Modal */}
            <Modal show={showEvent3} onHide={() => setShowEvent3(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>Professional Courses Merit List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Updated Date</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td>30-07-2024</td>
                                <td>M.B.B.S. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mbbs.jpeg.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Electronics & Instru.) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/b.tech_ei.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Agriculture Engineering) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/b.tech_ae.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Computer Science) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/b.tech_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>30-07-2024</td>
                                <td>M.B.B.S.- I (Only L.L.R.M. Medical College) Regular Course year
                                    2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mbbs-1st_llrm.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>30-07-2024</td>
                                <td>B.A.L.L.B. Campus Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ba_llb_campus.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>30-07-2024</td>
                                <td>M.I.B. Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mib.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Information Tech.) Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/B.tech_it.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Electronics & Commu.) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/b.tech_ec.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>30-07-2024</td>
                                <td>B.Sc. Honours (Computer Science) Campus Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bsc_hon_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>30-07-2024</td>
                                <td>B.A. (Journalism & Mass Communication) Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ba_jms.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>30-07-2024</td>
                                <td>B.P.T. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bpt.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>30-07-2024</td>
                                <td>B.Sc. Home Science (CLI, NUT, DIT) Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bsc_hs_cli_dit_nut.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>30-07-2024</td>
                                <td>M.S. Ayurvedic in (Prasuti Tantra Evum Stree Rog) Regular Course
                                    year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_aryuvedic.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>30-07-2024</td>
                                <td>M.C.A. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mca.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>30-07-2024</td>
                                <td>B.VOC (ACP) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bvoc_acp.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>30-07-2024</td>
                                <td>M.B.B.S. (Only L.L.R.M. Medical College) Regular Course year
                                    2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mbbs_llrm.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Chemical Engineering) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/b.tech_ce.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>30-07-2024</td>
                                <td>M.A. (Journalism & Mass Communication) Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_jmc.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>30-07-2024</td>
                                <td>B.Sc. (Computer Science) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bsc_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>30-07-2024</td>
                                <td>M.LIB Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/m.lib.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>30-07-2024</td>
                                <td>M.B.A. Campus Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mba_campus.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>30-07-2024</td>
                                <td>M.Sc. Home Science (TEX) Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_hs_tex.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>30-07-2024</td>
                                <td>M.Sc. (Computer Science) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>30-07-2024</td>
                                <td>M.B.B.S.- II Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mbbs-2nd.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>30-07-2024</td>
                                <td>M.Sc. Bio-Informatics Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_bio_informatics.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>30-07-2024</td>
                                <td>B.O.T. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bot.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>30-07-2024</td>
                                <td>BCA Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bca.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>01-08-2024</td>
                                <td>B.B.A. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/BBA.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>06-08-2024</td>
                                <td> B.Com Honours Regular course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bcom_hons.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>06-08-2024</td>
                                <td> B.Voc Yogic Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bvoc_yogic.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>06-08-2024</td>
                                <td>B.Sc. Microbiology - III Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc_microbiology_3.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>06-08-2024</td>
                                <td>Revised B.Tech Mechanical Engineering Regular Course Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/btech%20mechanical%20engineering.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>06-08-2024</td>
                                <td>B.Sc. Biotechnology Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc%20biotechnology.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>06-08-2024</td>
                                <td>M.Sc. Bio-chemistry Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc%20bio-chem.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>06-08-2024</td>
                                <td>M.B.B.S-III Prof. Part-I Regualr Course Year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mbbs%203%20prof%20part%201.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>06-08-2024</td>
                                <td>Revised M.Sc. Microbiology Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc%20microbiology.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>06-08-2024</td>
                                <td>B.Voc in Tour & Tourism Management Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bvoc%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>06-08-2024</td>
                                <td>B.Voc in (Mediacl Lab & Molecular) Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bvoc.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>06-08-2024</td>
                                <td>B.P.E.S Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bpes.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>06-08-2024</td>
                                <td>B.D.S Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bds.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>08-08-2024</td>
                                <td>B.F.A.-IV Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bfa-4.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>08-08-2024</td>
                                <td>Revised M.P.Ed Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mped.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>08-08-2024</td>
                                <td>M.P.E.S. Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mpes.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>11-08-2024</td>
                                <td>B.Lib Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/blib-2.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>11-08-2024</td>
                                <td>M.Sc. Bio-Tech Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-biotech.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>11-08-2024</td>
                                <td>M.Sc. Home Science Food & Nutrition Regular Course Year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-homesc-food.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>11-08-2024</td>
                                <td>B.P.Ed Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bped.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>49</td>
                                <td>12-08-2024</td>
                                <td> B.Sc. Home Science Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc-home-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>12-08-2024</td>
                                <td> M.B.A. (HA) Campus Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mba-he-campus.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>51</td>
                                <td>13-08-2024</td>
                                <td>M.Sc. Home Science (Human Development) Regular Course Year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-home-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>52</td>
                                <td>14-08-2024</td>
                                <td>Revised M.Tech Electronics & Communication Campus Regular Course
                                    Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/m.tech-electronics-comm-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>53</td>
                                <td>14-08-2024</td>
                                <td> Revised M.Tech Computer Science Campus Regular Course Year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/m.tech-comp-sc-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>54</td>
                                <td>20-08-2024</td>
                                <td> B.U.M.S IVth Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bums-4th.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>55</td>
                                <td>20-08-2024</td>
                                <td> B.A.M.S IVth Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bams-4th.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>56</td>
                                <td>23-08-2024</td>
                                <td> B.Sc. Nursing Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc-nursing.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>57</td>
                                <td>24-08-2024</td>
                                <td>B.A.M.S-4 Regular Course Year 2022</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bamms-4.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>

                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent3(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Event 4 Modal */}
            <Modal show={showEvent4} onHide={() => setShowEvent4(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>Confidential Merit List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Updated Date</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td>25-07-2024</td>
                                <td>Merit for B.sc. Physical Education & Sports</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/phy_edu_merit_conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>27-07-2024</td>
                                <td>Regarding B.Sc. Agriculture Merit List</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/agriculture_merit.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>31-07-2024</td>
                                <td>M.A. Defence Studies Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_def_stu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>31-07-2024</td>
                                <td>M.A. Economics Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_eco.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>31-07-2024</td>
                                <td>M.A. Education Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_edu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>31-07-2024</td>
                                <td>M.A. English Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_eng.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>31-07-2024</td>
                                <td>M.A. Hindi Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_hindi.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>31-07-2024</td>
                                <td>M.A. Philosophy Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_phil.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>31-07-2024</td>
                                <td>M.A. Physical Education Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_phy_edu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>31-07-2024</td>
                                <td>M.A. Political Science Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_pol_sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>31-07-2024</td>
                                <td>M.A. Psychology Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_psy.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>31-07-2024</td>
                                <td>M.A. Sanskrit Regular, Private course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_sanskrit.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>31-07-2024</td>
                                <td>M.A. Urdu Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_urdu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>31-07-2024</td>
                                <td>M.Sc. (Ag.) EXT. Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_ag_ext.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>31-07-2024</td>
                                <td>M.Sc. Ag. Genetics & Plant Breeding Regular Course year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_ag_gen_plant.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>31-07-2024</td>
                                <td>M.A. Mathematics Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-math.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>01-08-2024</td>
                                <td>B.A. LL.B Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/BALLB.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>01-08-2024</td>
                                <td>B.Com LL.B Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/BCOMLLB.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>03-08-2024</td>
                                <td>M.Sc. (AG) Agronomy Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/001%20(27).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>03-08-2024</td>
                                <td>M.Sc. (AG) AG-ECO Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/002%20(30).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>03-08-2024</td>
                                <td>M.Sc. (AG) Dairy SC & TECH Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/003%20(19).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>03-08-2024</td>
                                <td>M..A. History Regular & Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/008%20(4).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>07-08-2024</td>
                                <td>M.A. Music Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_music.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>07-08-2024</td>
                                <td>M.A. Sociology Regular & Professional Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_sociology.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>08-08-2024</td>
                                <td> M.Com Regular & Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mcom.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>08-08-2024</td>
                                <td>M.Sc. Botany Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-bot.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>08-08-2024</td>
                                <td> M.S.c Statistic Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-stat.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>08-08-2024</td>
                                <td> M.Sc. Zoology Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-zoo.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>08-08-2024</td>
                                <td>M.Sc. Physics Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-phy.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>10-08-2024</td>
                                <td>M.A. Home Science Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-home-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>11-08-2024</td>
                                <td>L.L.B Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/llb.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>11-08-2024</td>
                                <td>M.A. Visual Arts (D & P) Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-visual-arts.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>11-08-2024</td>
                                <td>M.A. Geography Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-geo.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>11-08-2024</td>
                                <td>M.Sc. AG Horticulture Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-hoti.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>12-08-2024</td>
                                <td> LL.M. Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/llm-regular.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>12-08-2024</td>
                                <td> Revised M.Sc. Mathematics Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/rev-msc-maths.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>12-08-2024</td>
                                <td> M.Sc. Chemistry Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-chem-2.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>12-08-2024</td>
                                <td> M.Sc. (Ag) CHE & Soil Sc. Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-ag-che-soli-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>13-08-2024</td>
                                <td>M.Ed Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/med-reg-course.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>13-08-2024</td>
                                <td> B.A.B.ED Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-bed.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>21-08-2024</td>
                                <td>Revised B.EL.ED Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/belded-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>22-08-2024</td>
                                <td>M.A. Sanskrit Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-sanskrit-2.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>23-08-2024</td>
                                <td>B.A. Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-pvt.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>24-08-2024</td>
                                <td>B.Com Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bcom.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>24-08-2024</td>
                                <td>B.Com N.E.P Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bcom-nep.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>27-08-2024</td>
                                <td>Revised B.A. N.E.P Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-nep-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>28-08-2024</td>
                                <td>B.Sc. (N.E.P) Mathematics Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/math-nep.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>28-08-2024</td>
                                <td> B.A. (N.E.P) Hindi Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-nep-hindi.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>49</td>
                                <td>28-08-2024</td>
                                <td> B.A. Hindi Private Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-nep-hindi-pvt.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>28-08-2024</td>
                                <td> B.Sc. N.E.P Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc-nep-reg.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>51</td>
                                <td>29-08-2024</td>
                                <td> Revised B.Ed Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/b.ed-reg-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>

                            <tr>
                                <td>52</td>
                                <td>29-08-2024</td>
                                <td>Revised M.Sc. Mathematics Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/maths-rev-msc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>


                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent4(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Main;
